import { render, staticRenderFns } from "./FiltersSearch.vue?vue&type=template&id=0be243f4&scoped=true"
import script from "./FiltersSearch.vue?vue&type=script&lang=js"
export * from "./FiltersSearch.vue?vue&type=script&lang=js"
import style0 from "./FiltersSearch.vue?vue&type=style&index=0&id=0be243f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be243f4",
  null
  
)

export default component.exports